import { prop } from 'ramda';
import { useCallback } from 'react';
import { useAppSelector } from '@core/js/store/hooks';
import { getLocationParam } from '@core/js/utils/url.util';

import * as pas from '@theme/js/hooks/auth/pas';

import { useBeforeLoginAction as useBeforeLoginActionCore } from '@core/js/hooks/auth/hooks/useBeforeLoginAction';

export const useBeforeLoginAction = () => {
    const clientChannel = getLocationParam('clientChannel');
    const clientTypeFromURL = getLocationParam('clientType');
    const clientTypeFromApp = useAppSelector(prop('clientType'));
    const beforeLoginAction = useBeforeLoginActionCore();

    return useCallback(async () => {
        await beforeLoginAction();

        if (clientChannel) {
            pas.setClientChannel(clientChannel);
        }

        if (clientTypeFromURL) {
            pas.setClientType(clientTypeFromURL);
        } else {
            pas.setClientType(clientTypeFromApp);
        }
    }, [beforeLoginAction, clientChannel, clientTypeFromURL, clientTypeFromApp]);
};
